// Parameters format note for config.

    // {
    //     project-name : name of project (in TH),
    //     service-type : gas, hood, goods, fab,
    //     description : service description to explain in page (in TH),
    //     images : list of image to show (first img is used for img preview)
    // }


    // {
    //     'project-name':'',
    //     'service-type':[''],
    //     'description':'',
    //     'images':[
    //          require(''),
    //              ]
    // },

const projectData = [
    {
        'project-name':'ภ.คิทเช่น ศรีนครินทร์',
        'service-type':['gas','hood','goods'],
        'description':'งานติดตั้งครัวครบวงจร ร้าน ภ.คิทเช่น ศรีนครินทร์',
        'images':[
            require('../images/project/ภ.คิทเช่น/LINE_ALBUM_ร้าน ภ.คิทเช่น ศรีนครินทร์_240809_1.jpg'),
            require('../images/project/ภ.คิทเช่น/LINE_ALBUM_ร้าน ภ.คิทเช่น ศรีนครินทร์_240809_3.jpg'),
            require('../images/project/ภ.คิทเช่น/LINE_ALBUM_ร้าน ภ.คิทเช่น ศรีนครินทร์_240809_5.jpg'),
        ]
    },
    {
        'project-name':'โรงแรม เบสเวสเทิร์น',
        'service-type':['hood','goods'],
        'description':'งานติดตั้งระบบดูดอากาศ และงานผลิตเครื่องครัว โรงแรง เบสเวสเทิร์น',
        'images':[
            require('../images/project/โรงแรมเบสเวสเทิร์น/LINE_ALBUM_โรงแรม เบสเวสเทิร์น จตุจักร_240809_11.jpg'),
            require('../images/project/โรงแรมเบสเวสเทิร์น/LINE_ALBUM_โรงแรม เบสเวสเทิร์น จตุจักร_240809_4.jpg'),
            require('../images/project/โรงแรมเบสเวสเทิร์น/LINE_ALBUM_โรงแรม เบสเวสเทิร์น จตุจักร_240809_1.jpg'),
        ]
    },
    {
        'project-name':'เลิฟยูหม่าล่า',
        'service-type':['hood','goods'],
        'description':'งานติดตั้งระบบดูดอากาศ และงานผลิตเครื่องครัว ร้านเลิฟยูหม่าล่า',
        'images':[
            require('../images/project/เลิฟยูหม่าล่า/LINE_ALBUM_เลิฟยูหม่าล่า โชคชัย4_240809_10.jpg'),
            require('../images/project/เลิฟยูหม่าล่า/LINE_ALBUM_เลิฟยูหม่าล่า โชคชัย4_240809_11.jpg'),
        ]
    },
]

export default projectData;